import { AType, summon } from "@silversea-ssc/functional-support"
import { Currency } from "../currency"

export const UnitSystem = /* @__PURE__ */ summon((F) => F.keysOf({ feet: null, meter: null }))
export type UnitSystem = AType<typeof UnitSystem>

export const GeoLocationResponse = /* @__PURE__ */ summon((F) =>
    F.interface(
        {
            countryCode: F.string(),
            unit: UnitSystem(F),
            phone: F.nullable(F.string()),
            market: F.string(),
            defaultCurrency: Currency(F),
            countryPath: F.string(),
        },
        "GeoLocationResponse",
    ),
)
export type GeoLocationResponse = AType<typeof GeoLocationResponse>
